module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("5bLPT"))).then(() => parcelRequire('5Mgi1'));